const inviteAddTenant = {
  toastr: 'Tenant agregado',
  toastr1: 'El tenant fue agregado con éxito.',
  toastrError: 'Contraseña Incorrecta'
};

export default inviteAddTenant;
